import { FC, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { SuspensedView } from '@components/SuspensedView'

import { MasterLayout } from '@/layouts/MasterLayout'

const VaccineRoutes = lazy(() => import('@/routes/admin/VaccineRoutes'))
const PharmacistRoutes = lazy(() => import('@/routes/admin/PharmacistRoutes'))
const AdminClinicRoutes = lazy(() => import('@/routes/admin/ClinicRoutes'))
const AdminCashDepositRoutes = lazy(() => import('@/routes/admin/CashDepositRoutes'))
const AdminVoucherGenerateRuleRoutes = lazy(() => import('@/routes/admin/VoucherGenerateRuleRoutes'))
const BankRoutes = lazy(() => import('@/routes/admin/BankRoutes'))
const BookingHolidayRoutes = lazy(() => import('@/routes/admin/BookingHolidayRoutes'))
const ClientCorporateRoutes = lazy(() => import('@/routes/admin/ClientCorporateRoutes'))
const DoctorRoutes = lazy(() => import('@/routes/admin/DoctorRoutes'))
const GlobalSettingRoutes = lazy(() => import('@/routes/admin/GlobalSettingRoutes'))
const InjectionRoutes = lazy(() => import('@/routes/admin/InjectionRoutes'))
const MedicineRoutes = lazy(() => import('@/routes/admin/MedicineRoutes'))
const NurseRoutes = lazy(() => import('@/routes/admin/NurseRoutes'))
const SupplierRoutes = lazy(() => import('@/routes/admin/SupplierRoutes'))
const MedicinalControlledDrugClassificationRoutes = lazy(
  () => import('@/routes/admin/MedicinalControlledDrugClassificationRoutes')
)
const TreatmentRoutes = lazy(() => import('@/routes/admin/TreatmentRoutes'))
const TreatmentCategoryRoutes = lazy(() => import('@/routes/admin/TreatmentCategoryRoutes'))
const ExaminationRoutes = lazy(() => import('@/routes/admin/ExaminationRoutes'))
const ExaminationCategoryRoutes = lazy(() => import('@/routes/admin/ExaminationCategoryRoutes'))
const MedicinalAttentionRoutes = lazy(() => import('@/routes/admin/MedicinalAttentionRoutes'))
const MedicinalInstructionRoutes = lazy(() => import('@/routes/admin/MedicinalInstructionRoutes'))
const MedicinalFormRoutes = lazy(() => import('@/routes/admin/MedicinalFormRoutes'))
const ICD10TrendingsPage = lazy(() => import('@/routes/admin/ICD10TrendingRoutes'))
const InsuranceRoutes = lazy(() => import('@/routes/admin/InsuranceRoutes'))
const DeveloperToolRoutes = lazy(() => import('@/routes/admin/DeveloperToolRoutes'))
const MedicinalRouteRoutes = lazy(() => import('@/routes/admin/MedicinalRouteRoutes'))
const MedicinalClassificationRoutes = lazy(() => import('@/routes/admin/MedicinalClassificationRoutes'))
const MedicinalCategoryRoutes = lazy(() => import('@/routes/admin/MedicinalCategoryRoutes'))
const MedicalRecordTemplateRoutes = lazy(() => import('@/routes/admin/MedicalRecordTemplateRoutes'))
const RetailProductRoutes = lazy(() => import('@/routes/admin/RetailProductRoutes'))
const RetailProductCategoryRoutes = lazy(() => import('@/routes/admin/RetailProductCategoryRoutes'))
const VirtualMedicinalProductRoutes = lazy(() => import('@/routes/admin/VirtualMedicinalProductRoutes'))
const VirtualTherapeuticMoietyRoutes = lazy(() => import('@/routes/admin/VirtualTherapeuticMoietyRoutes'))
const VoucherCodeRoutes = lazy(() => import('@/routes/admin/VoucherCodeRoutes'))
const QualificationTypeRoutes = lazy(() => import('@/routes/admin/QualificationTypeRoutes'))
const UnitRoutes = lazy(() => import('@/routes/admin/UnitRoutes'))
const UserRoutes = lazy(() => import('@/routes/admin/UserRoutes'))
const MedicalToolRoutes = lazy(() => import('@/routes/admin/MedicalToolRoutes'))
const ProductBundlingRoutes = lazy(() => import('@/routes/admin/ProductBundlingRoutes'))
const ProductPromotionRoutes = lazy(() => import('@/routes/admin/ProductPromotionRoutes'))
const InsurancePayorRoutes = lazy(() => import('@/routes/admin/InsurancePayorRoutes'))
const RadiographerRoutes = lazy(() => import('@/routes/admin/RadiographerRoutes'))

type Props = {}

const AdminRoutes: FC<Props> = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path="clinics/*"
          element={
            <SuspensedView>
              <AdminClinicRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="doctors/*"
          element={
            <SuspensedView>
              <DoctorRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="nurses/*"
          element={
            <SuspensedView>
              <NurseRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicines/*"
          element={
            <SuspensedView>
              <MedicineRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="injections/*"
          element={
            <SuspensedView>
              <InjectionRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="vaccines/*"
          element={
            <SuspensedView>
              <VaccineRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medical-tools/*"
          element={
            <SuspensedView>
              <MedicalToolRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-controlled-drug-classifications/*"
          element={
            <SuspensedView>
              <MedicinalControlledDrugClassificationRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-attentions/*"
          element={
            <SuspensedView>
              <MedicinalAttentionRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-instructions/*"
          element={
            <SuspensedView>
              <MedicinalInstructionRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-forms/*"
          element={
            <SuspensedView>
              <MedicinalFormRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-routes/*"
          element={
            <SuspensedView>
              <MedicinalRouteRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-classifications/*"
          element={
            <SuspensedView>
              <MedicinalClassificationRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medicinal-categories/*"
          element={
            <SuspensedView>
              <MedicinalCategoryRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="medical-record-templates/*"
          element={
            <SuspensedView>
              <MedicalRecordTemplateRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="units/*"
          element={
            <SuspensedView>
              <UnitRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="suppliers/*"
          element={
            <SuspensedView>
              <SupplierRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="banks/*"
          element={
            <SuspensedView>
              <BankRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="treatments/*"
          element={
            <SuspensedView>
              <TreatmentRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="treatment-categories/*"
          element={
            <SuspensedView>
              <TreatmentCategoryRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="examinations/*"
          element={
            <SuspensedView>
              <ExaminationRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="examination-categories/*"
          element={
            <SuspensedView>
              <ExaminationCategoryRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="settings/*"
          element={
            <SuspensedView>
              <GlobalSettingRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="cash-deposit/*"
          element={
            <SuspensedView>
              <AdminCashDepositRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="retail-products/*"
          element={
            <SuspensedView>
              <RetailProductRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="retail-product-categories/*"
          element={
            <SuspensedView>
              <RetailProductCategoryRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="virtual-therapeutic-moieties/*"
          element={
            <SuspensedView>
              <VirtualTherapeuticMoietyRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="virtual-medicinal-products/*"
          element={
            <SuspensedView>
              <VirtualMedicinalProductRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="voucher-generate-rules/*"
          element={
            <SuspensedView>
              <AdminVoucherGenerateRuleRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="voucher-codes/*"
          element={
            <SuspensedView>
              <VoucherCodeRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="qualification-types/*"
          element={
            <SuspensedView>
              <QualificationTypeRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="users/*"
          element={
            <SuspensedView>
              <UserRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="pharmacists/*"
          element={
            <SuspensedView>
              <PharmacistRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="radiographers/*"
          element={
            <SuspensedView>
              <RadiographerRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="icd-10-trendings/*"
          element={
            <SuspensedView>
              <ICD10TrendingsPage />
            </SuspensedView>
          }
        />

        <Route
          path="product-bundlings/*"
          element={
            <SuspensedView>
              <ProductBundlingRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="product-promotions/*"
          element={
            <SuspensedView>
              <ProductPromotionRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="insurance-payors/*"
          element={
            <SuspensedView>
              <InsurancePayorRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="insurances/*"
          element={
            <SuspensedView>
              <InsuranceRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="developer-tools/*"
          element={
            <SuspensedView>
              <DeveloperToolRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="booking-holidays/*"
          element={
            <SuspensedView>
              <BookingHolidayRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="client-corporates/*"
          element={
            <SuspensedView>
              <ClientCorporateRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
      </Route>
    </Routes>
  )
}

export { AdminRoutes }
